
// @ is an alias to /src
import { defineComponent } from "vue";
import axios from "axios";
import { SubLink } from "./types";
import Dark from 'quasar/src/plugins/Dark.js';;

interface createToken {
  message: string;
  Key: string;
}

interface componentData {
  leftDrawerOpen: boolean;
  loading: boolean;
}

export default defineComponent({
  name: "App",
  data(): componentData {
    return {
      leftDrawerOpen: false,
      loading: false,
    };
  },
  computed: {
    subNavigationLinks(): Array<SubLink> {
      return this.$store.getters.getLinks;
    },
  },
  created() {
    Dark.set(true);
  },
});
